import styled from 'styled-components';

export const StyledLayersPanel = styled.div`
  width: 100%;
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
  padding: 0 0 10px;
  overflow: hidden;
`;

export const StyledLayersPanelTitle = styled.h3`
  font-family: Poppins, system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  margin: 0 0 10px;
  color: var(--primary-color);
  letter-spacing: 0.2px;
`;

export const StyledLayersPanelEmpty = styled.p`
  font-family: Poppins, system-ui, sans-serif;
  font-size: 12px;
  margin: 0;
  padding: 4px 12px 8px;
  color: var(--theme-overlay-muted, #6b7280);
  line-height: 1.45;
`;

export const StyledLayersList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const StyledLayerRow = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid var(--theme-overlay-row-border, #e5eaf2);
  background: var(--theme-overlay-row-bg, #f8fafb);
  cursor: pointer;
  box-sizing: border-box;
  transition: background 0.15s ease, border-color 0.15s ease;

  &[data-selected='true'] {
    border-color: var(--primary-color);
    background: var(--theme-overlay-row-selected, #fff);
    box-shadow: 0 0 0 1px rgb(248 85 142 / 12%);
  }

  &[data-dragging='true'] {
    opacity: 0.55;
  }

  &[data-drop-target='true'] {
    outline: 2px dashed var(--primary-color);
    outline-offset: 1px;
  }

  &:hover {
    background: var(--theme-overlay-row-hover, #fff);
    border-color: var(--theme-overlay-border, #d5dae3);
  }
`;

export const StyledLayerDragHandle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  color: var(--theme-overlay-muted, #6b7280);
  cursor: grab;

  &[data-disabled='true'] {
    opacity: 0.35;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const StyledLayerRowLabel = styled.span`
  flex: 1;
  min-width: 0;
  font-family: Poppins, system-ui, sans-serif;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--theme-overlay-text, #1f2937);
  letter-spacing: 0.15px;
`;

export const StyledLayerRowActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--theme-overlay-text, #374151);
  cursor: pointer;

  &:hover:not(:disabled) {
    background: var(--theme-overlay-hover, #eef0f4);
    color: var(--primary-color);
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }

  &[data-hidden='true'] {
    opacity: 0.4;
  }
`;

export const StyledLayerVisibilityButton = styled(StyledLayerRowActionButton)``;

export const StyledLayerDeleteButton = styled(StyledLayerRowActionButton)`
  &:hover:not(:disabled) {
    background: #fef2f2;
    color: #dc2626;
  }
`;

export const StyledLayerLockBadge = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  color: #d97706;
`;
